import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CustomerImageModule } from '../../customer/image/customer-image.module';
import { BaseCorrespondenceComponent } from '../base/correspondence-base.component';
import { ViewCorrespondenceComponent } from '../view/correspondence-view.component';

@NgModule({
    declarations: [
        BaseCorrespondenceComponent,
        ViewCorrespondenceComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        CustomerImageModule,
        TableModule,
        ToastModule
    ],
    exports: [
        BaseCorrespondenceComponent,
        ViewCorrespondenceComponent
    ]
})
export class CreateCorrespondenceModule {
}
